// extracted by mini-css-extract-plugin
export var button = "Button-module--button--094fe";
export var disabled = "Button-module--disabled--cd4ef";
export var fadeInAnimation = "Button-module--fadeInAnimation--cba71";
export var fullWidthMobile = "Button-module--fullWidthMobile--02ce7";
export var header = "Button-module--header--57da8";
export var md = "Button-module--md--5e507";
export var primary = "Button-module--primary--f4199";
export var secondary = "Button-module--secondary--042be";
export var sm = "Button-module--sm--b0909";